import { useEffect, useRef } from 'react';

/**
 * @param length  - aktualna długość listy
 * @param getId   - funkcja zwracająca id elementu DOM dla danego indeksu
 */
const useFocusNewItem = (length: number, getId: (index: number) => string): void => {
  const prevLengthRef = useRef(length);

  useEffect(() => {
    if (length > prevLengthRef.current) {
      const newIndex = length - 1;
      const input = document.getElementById(getId(newIndex));
      input?.focus();
    }
    prevLengthRef.current = length;
  }, [length, getId]);
};

export default useFocusNewItem;

